module.exports = __webpack_public_path__ + "img/stock-poster.9854f610.jpg";